export default __webpack_public_path__ + "models/bfaae751aadec205ace7ef76761394b2.glb";